const formatPhoneNumber = (inputPhoneNumber) => {
    if (!inputPhoneNumber) {
        return '';
    }

    const cleanPhoneNumber = inputPhoneNumber.replace(/\D/g, '');
    let formattedNumber = cleanPhoneNumber.match(/.{1,2}/g)
    formattedNumber = formattedNumber == null ? "" : cleanPhoneNumber.match(/.{1,2}/g).join(' ');
    return formattedNumber;

};
export default formatPhoneNumber;
